import { useCallback } from 'react';

import type { Bays } from '../../../../../utils/types';
import type { PlanDialogRequests, PlanDialogRequestsDependencies } from './types';

export default function usePlanDialogRequests({
  activeTreatmentPlanId,
  openDialog,
}: PlanDialogRequestsDependencies): PlanDialogRequests {
  const requestActivate = useCallback(() => {
    openDialog(
      activeTreatmentPlanId === undefined ? { kind: 'activate' } : { kind: 'existingActive' },
    );
  }, [activeTreatmentPlanId, openDialog]);

  const requestDeactivate = useCallback(() => openDialog({ kind: 'deactivate' }), [openDialog]);
  const requestEdit = useCallback(() => openDialog({ kind: 'edit' }), [openDialog]);
  const requestDelete = useCallback(() => openDialog({ kind: 'delete' }), [openDialog]);
  const requestDownload = useCallback(() => openDialog({ kind: 'download' }), [openDialog]);
  const requestClone = useCallback(
    (bay: Bays) => openDialog({ kind: 'clonePlan', bay }),
    [openDialog],
  );
  const requestSwitchPlan = useCallback(
    (treatmentPlanId: number) => openDialog({ kind: 'switchPlan', treatmentPlanId }),
    [openDialog],
  );

  return {
    requestActivate,
    requestDeactivate,
    requestEdit,
    requestDelete,
    requestDownload,
    requestClone,
    requestSwitchPlan,
  };
}
